import { TerminateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Terminate')
export class TerminateConnectorProvider extends ConnectorProvider<TerminateWorkflowNode> {}
